import { RoomTypes } from '~analytics/types';

import { sendLaunchExitTicketEvent } from '../index';
import { EventAdapter } from './EventAdapter';

export class LaunchExitTicketEventAdapter extends EventAdapter {
  protected intercomEventKey = 'launch-exit-ticket';
  protected amplitudeEventFunction = sendLaunchExitTicketEvent;

  constructor(isRosteredRoom: boolean) {
    super();

    try {
      const roomType = isRosteredRoom
        ? RoomTypes.RosteredRoom
        : RoomTypes.OpenRoom;
      this.eventData = {
        room_type: roomType,
      };
    } catch (err) {
      console.error('Error parsing analytics data', err);
    }
  }
}
